import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "SocialShare",
    component: () => (__SERVER__ ? require("./social-share-view") : import("./social-share-view"))
});

export default definition;
